import { PUBLICATION_NAMES as PUB_NAME, publicationColor } from '../lib/format'

const PUB_SHORT: Record<string, string> = {
  rc_car_action: 'RCC',
  model_airplane_news: 'MAN',
  flight_journal: 'FLJ',
  diecast: 'DIE',
}

export function PubBadge({ slug, compact = false }: { slug: string; compact?: boolean }) {
  const color = publicationColor(slug)
  if (compact) {
    return (
      <span
        className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-label"
        style={{ color }}
        title={PUB_NAME[slug] ?? slug}
      >
        <span className="w-1.5 h-1.5" style={{ backgroundColor: color }} />
        {PUB_SHORT[slug] ?? slug.slice(0, 3).toUpperCase()}
      </span>
    )
  }
  return (
    <span
      className="inline-flex items-center gap-2 px-2 py-0.5 font-mono text-[10px] uppercase tracking-label border"
      style={{ color, borderColor: `${color}40` }}
    >
      <span className="w-1.5 h-1.5" style={{ backgroundColor: color }} />
      {PUB_NAME[slug] ?? slug}
    </span>
  )
}
